export enum SuperAdminPermission {
  Master = 'master',
  TwismWallet = 'twism-wallet',
  CustomerDelete = 'customer-delete',
  OfferUpdate = 'offer-update',
  KeywordUpdate = 'keyword-update',
  TicketUpdate = 'ticket-update',
  TicketCreate = 'ticket-create'
}
